import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d69209e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "address-config-title" }
const _hoisted_2 = { class: "tip" }
const _hoisted_3 = {
  key: 0,
  class: "error-info"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { t } from '@/plugins/i18n'
import { ref, toRaw, watch, computed } from 'vue'
import { cloneDeep } from 'lodash'
import { clearForm, setDefaultForm } from '@/util/common'
import { updateShopOrderAddress } from '@/apis/order'
import { ElMessage, FormInstance } from 'element-plus'
import { getAreaTxt, getCityTxt, setAreaTxt, setCityTxt } from './data'
import useRules, { useMust } from '@/util/useRules'
import CommonDialog from '@/components/common/CommonDialog.vue'
import SortSelect from '@/components/common/SortSelect.vue'
import { getAreaList } from '@/util/useCountry'
import { isJA, isEN, isKO, isD2C } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  form: {
    type: Object,
    default: () => ({})
  },
  countryList: {
    type: Array,
    default: () => []
  }

},
  emits: ['update:visible', 'success'],
  setup(__props, { emit: emits }) {

const props = __props


const countryCode = ref('')
const provinces = ref([])
const defaultForm = {
  shopOrderId: '',
  shopOrderCustomerName: '',
  shopOrderTel: '',
  shopOrderProvince: '',
  shopOrderCity: '',
  shopOrderAddress: '',
  shopOrderPostalCode: '',
  shopOrderEmail: '',
  clearanceCode: ''
}

const cities: any = ref([])

const getForm = (form: any) => {
  const _form = cloneDeep(toRaw(form))
  _form.shopOrderProvince = getAreaTxt(form || {}, provinces.value)
  _form.shopOrderCity = getCityTxt(form || {}, provinces.value)
  return setDefaultForm(_form, defaultForm)
}

const setForm = (form: any) => {
  const _form = cloneDeep(toRaw(form))
  console.log(_form)
  // _form.shopOrderProvince = setAreaTxt(form || {}, props.provinces)
  // _form.shopOrderCity = setCityTxt(form || {}, props.provinces)
  return _form
}

const model = ref()
let countryItem: any = {} // 国家信息
const phoneCode = ref('')
watch(() => props.visible, (newValue) => {
  if (newValue) {
    console.log('props.form', props.form)
    const form = {
      shopOrderId: props.form?.shopOrderId,
      shopOrderCustomerName: props.form.receiver?.name,
      shopOrderTel: props.form.receiver?.phone,
      shopOrderProvince: props.form.receiver?.province,
      shopOrderCity: props.form.receiver?.city,
      shopOrderAddress: props.form.receiver?.address,
      shopOrderPostalCode: props.form.receiver?.postalCode,
      shopOrderEmail: props.form.receiver?.email,
      country: props.form.receiver?.country,
      clearanceCode: props.form.receiver?.clearanceCode
    }
    model.value = getForm(form)
    provinces.value = []
    cities.value = []
    if (props.form.receiver?.countryCode) {
      countryItem = props.countryList.find((i: any) => i.code === props.form.receiver?.countryCode)
      countryItem?.intAreaId && (model.value.country = countryItem?.intAreaId)
      countryItem?.areaNum && (phoneCode.value = '+' + countryItem?.areaNum)
      countryCode.value = countryItem?.code
      getAreaList({
        code: props.form.receiver?.countryCode,
        intAreaId: props.form.receiver?.countryId
      }).then((res: any) => {
        provinces.value = res
        cities.value = provinces.value.find((i: any) => i.name === form.shopOrderProvince || i.nameEn === form.shopOrderProvince)?.children || []
      })
    }
  }
})
const addressRef = ref<FormInstance>()
const submitLoading = ref(false)
const submit = () => {
  if (!addressRef.value) return
  console.log('countryItem', countryItem)
  addressRef.value.validate((valid) => {
    console.log(valid)
    if (valid) {
      submitLoading.value = true
      const form = setForm(model.value)
      updateShopOrderAddress({
        ...form,
        shopOrderId: props.form.shopOrderId,
        countryId: countryItem?.intAreaId,
        country: countryItem?.[getName()],
        countryCode: countryItem?.code
      }).then((res: any) => {
        if (res.success) {
          ElMessage.success(t('编辑成功'))
          setTimeout(() => { submitLoading.value = false }, 1000)
          emits('update:visible', false)
          emits('success')
        } else {
          submitLoading.value = false
        }
      }).catch(() => { submitLoading.value = false })
    } else {
      return false
    }
  })
}

const rules = computed(() => {
  return {
    shopOrderCustomerName: useRules({ message: t('收件人姓名不能为空'), key: 'deliver' }),
    shopOrderTel: useRules({ message: t('联系电话不能为空'), key: 'apiPhone' }),
    shopOrderProvince: useMust(t('都道府县不能为空'), 'change'),
    shopOrderCity: countryCode.value === 'US' ? useMust(t('市不能为空'), 'change') : undefined,
    shopOrderAddress: useRules({ message: t('详细地址不能为空'), key: model.value.country === '2115' ? 'address40' : 'address' }),
    shopOrderPostalCode: useRules({ message: t('邮编不能为空'), key: model.value.country === '2279' ? 'postal' : 'postalCode' }),
    shopOrderEmail: useRules({ message: t('邮箱格式不正确，请重新输入'), key: 'email' }),
    clearanceCode: isKO() ? useRules({ message: t('通关码不能为空'), key: 'clearanceCode' }) : undefined
  }
})
const changeCountry = (item: any) => {
  countryItem = item
  countryCode.value = item.code
  phoneCode.value = '+' + countryItem?.areaNum
  getAreaList(item).then((res: any) => {
    model.value.shopOrderProvince = ''
    model.value.shopOrderCity = ''
    model.value.shopOrderAddress = ''
    model.value.shopOrderPostalCode = ''
    provinces.value = res
    cities.value = []
    clearFomValidate()
  })
}
// 切换都道府县
const changeArea = (item: any) => {
  console.log(item)
  model.value.shopOrderCity = ''
  cities.value = item.children || []

}
const clearFomValidate = () => {
  setTimeout(() => {
    addressRef.value && addressRef.value.clearValidate()
  })
}
const isHaveProvinces = computed(() => {
  const item: any = provinces.value.find((i: any) => i[model.value.country === '2279' ? 'name' : 'nameEn'] === model.value.shopOrderProvince)

  return !!item?.intAreaId
})
const getName = () => {
  return isJA() ? 'nameJa' : 'nameEn'
}
const phoneAreaCode = computed(() => {
  if (model.value.shopOrderProvince === 'Hong Kong') {
    return '+852'
  }
  if (model.value.shopOrderProvince === 'Taiwan China') {
    return '+886'
  }
  if (model.value.shopOrderProvince === 'Macao') {
    return '+853'
  }
  return phoneCode.value ?? '-'
})

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(CommonDialog, {
    "model-value": __props.visible,
    "destroy-on-close": "",
    onCancel: _cache[9] || (_cache[9] = ($event: any) => (emits('update:visible', false))),
    footer: true,
    onOk: submit,
    className: "address-config-common-dialog"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createTextVNode(_toDisplayString(_unref(t)('物流信息')) + " ", 1),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('国际单号回传后不可修改')), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        class: "address-form",
        ref: (_value, _refs) => {
          _refs['addressRef'] = _value
          addressRef.value = _value
        },
        model: model.value,
        rules: _unref(rules),
        inline: true,
        "label-width": 138
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            prop: "country",
            label: _unref(t)('国/地区')
          }, {
            default: _withCtx(() => [
              _createVNode(SortSelect, {
                value: model.value.country,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((model.value.country) = $event)),
                onChange: changeCountry,
                list: __props.countryList,
                type: "country",
                rowKey: "intAreaId",
                width: 400
              }, null, 8, ["value", "list"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            prop: "shopOrderCustomerName",
            label: _unref(t)('收件人')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "text",
                modelValue: model.value.shopOrderCustomerName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.value.shopOrderCustomerName) = $event)),
                style: {"width":"400px"}
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            prop: "shopOrderTel",
            label: _unref(t)('联系电话')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "text",
                modelValue: model.value.shopOrderTel,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((model.value.shopOrderTel) = $event)),
                maxlength: 20,
                style: {"width":"400px"}
              }, {
                prepend: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(phoneAreaCode)), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('收件人邮箱'),
            prop: "shopOrderEmail"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: model.value.shopOrderEmail,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((model.value.shopOrderEmail) = $event)),
                style: {"width":"400px"}
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            prop: "shopOrderProvince",
            label: model.value.country === '2279' ? _unref(t)('都道府县') : _unref(t)('都道府県/州/地域')
          }, {
            default: _withCtx(() => [
              _createVNode(SortSelect, {
                value: model.value.shopOrderProvince,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((model.value.shopOrderProvince) = $event)),
                onChange: changeArea,
                list: provinces.value,
                type: "area",
                rowKey: model.value.country === '2279' ? 'name' : 'nameEn',
                width: 400,
                country: model.value.country
              }, null, 8, ["value", "list", "rowKey", "country"]),
              (!_unref(isHaveProvinces) && model.value.shopOrderProvince)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createTextVNode(_toDisplayString(_unref(t)('お届け先住所の形式が正しくありません')), 1),
                    _hoisted_4,
                    _createTextVNode(" " + _toDisplayString(_unref(t)('再度確認してから提出してください')), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            prop: "shopOrderCity",
            label: _unref(t)('市')
          }, {
            default: _withCtx(() => [
              _createVNode(SortSelect, {
                value: model.value.shopOrderCity,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((model.value.shopOrderCity) = $event)),
                list: cities.value,
                type: "area",
                rowKey: model.value.country === '2279' ? 'name' : 'nameEn',
                width: 400,
                country: model.value.country
              }, null, 8, ["value", "list", "rowKey", "country"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            prop: "shopOrderAddress",
            label: _unref(t)('详细地址')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "textarea",
                autosize: { minRows: 2, maxRows: 4 },
                style: {"width":"400px"},
                modelValue: model.value.shopOrderAddress,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((model.value.shopOrderAddress) = $event)),
                maxlength: 100,
                placeholder: _unref(t)('请输入详细地址')
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            prop: "shopOrderPostalCode",
            label: _unref(t)('邮编')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "text",
                modelValue: model.value.shopOrderPostalCode,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((model.value.shopOrderPostalCode) = $event)),
                style: {"width":"400px"},
                maxlength: 20
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_unref(isKO)() && _unref(isD2C)())
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                prop: "clearanceCode",
                label: _unref(t)('个人通关码')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "text",
                    modelValue: model.value.clearanceCode,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((model.value.clearanceCode) = $event)),
                    style: {"width":"400px"},
                    maxlength: 20
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})